import { EVALUE, FIELD_LABELS } from "./consts";


export default class FieldHelper {

    field_data: { [field: string]: { label: string, min: any, max: any } };

    constructor() {
        this.field_data = {};

        Object.entries(FIELD_LABELS).forEach(([field, label], index, arr) => {

            this.field_data[field] = { label: label, min: undefined, max: undefined };


        })
    }


    setMin(field: string, value: any) {
        this.field_data[field.toLowerCase()].min = value;
    }

    setMax(field: string, value: any) {
        this.field_data[field.toLowerCase()].max = value;
    }

    getMin(field: string) {
        return this.field_data[field.toLowerCase()].min;
    }

    getMax(field: string) {
        return this.field_data[field.toLowerCase()].max;
    }

    getLabel(field: string) {

        const field_ = field.toLowerCase();

        const data = this.field_data[field_];
        
        if (data === undefined) {
            console.log(field_);
            return "";
        }
        
        return data.label;        
    }

}